'use client'

import React from 'react'

import { isServer } from '@rewardops/utils'

import { isAirCanada } from '~/utils/public-tenant-utils'
import { useApi } from '~/components/hooks/use-api'
import AirCanadaEventCache from '~/custom/air-canada/air-canada-event-cache'
import { AcEventParams } from '../air-canada-types'
import { useAirCanadaEvent } from '../use-air-canada-event'

const AirCanadaHomePageEvent = React.memo(() => {
  const { tenant } = useApi()
  const { fireAirCanadaEvent } = useAirCanadaEvent()
  const eventKey = `homepage`

  if (
    !isAirCanada(tenant) ||
    isServer() ||
    AirCanadaEventCache.hasEvent(eventKey)
  ) {
    return null
  }

  const event: AcEventParams = {
    attributes: {
      pageType: 'content',
      pageTitle: `aeroplan_apple|home`,
      pageHierarchy: {
        level2: 'home',
        level3: null,
        level4: null,
      },
    },
    event: {
      dataLayerID: 'web-apple-estore-01-01',
    },
  }

  const hasFired = fireAirCanadaEvent(event)

  if (hasFired) {
    AirCanadaEventCache.addEvent(eventKey)
  }

  return null
})

export { AirCanadaHomePageEvent }
